
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LiberisIcon',
  props: {
    twClass: {
      type: [String],
      default: ""
    }
  }
})
